import { MapPin, Calendar, Mail, ExternalLink } from "lucide-react";

export default function Footer() {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer data-testid="footer" className="bg-[#040812] border-t border-[#D4AF37]/15 py-14 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Gold top rule */}
        <div className="gold-divider mb-12" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          {/* Brand */}
          <div data-testid="footer-brand">
            <p className="overline-gold text-[0.6rem] mb-2">Presented By</p>
            <h3 className="font-['Cormorant_Garamond'] text-2xl text-white font-semibold tracking-widest uppercase mb-1">Digpu</h3>
            <p className="overline-gold text-[0.58rem] tracking-[0.3em]">News &amp; Media</p>
            <p className="text-[#94A3B8] text-xs font-['Outfit'] mt-4 leading-relaxed max-w-xs">
              An internationally recognised media and PR agency connecting global diplomacy with Indian industry leadership.
            </p>
          </div>

          {/* Event details */}
          <div data-testid="footer-event-details">
            <p className="overline-gold text-[0.6rem] mb-4">The Dialogue</p>
            <p className="font-['Cormorant_Garamond'] text-base text-white font-medium leading-snug mb-4">
              EU–India Special Policy &amp;<br />Business Dialogue
            </p>
            <div className="flex flex-col gap-2 text-[#94A3B8] text-xs font-['Outfit']">
              <span className="flex items-center gap-2">
                <Calendar size={12} className="text-[#D4AF37]" />
                Monday, 27 April 2026
              </span>
              <span className="flex items-center gap-2">
                <MapPin size={12} className="text-[#D4AF37]" />
                DoubleTree by Hilton, Ahmedabad
              </span>
              <span className="flex items-center gap-2">
                <ExternalLink size={12} className="text-[#D4AF37]" />
                By Invitation Only · 50 Seats
              </span>
            </div>
          </div>

          {/* Quick links */}
          <div data-testid="footer-links">
            <p className="overline-gold text-[0.6rem] mb-4">Quick Links</p>
            <div className="flex flex-col gap-3">
              {[
                { label: "About the Speaker", id: "speaker" },
                { label: "Programme", id: "agenda" },
                { label: "Organisers", id: "organisers" },
                { label: "Why Attend", id: "why-attend" },
                { label: "Request Invitation", id: "register" },
              ].map(({ label, id }) => (
                <button
                  key={id}
                  data-testid={`footer-link-${id}`}
                  onClick={() => scrollTo(id)}
                  className="text-[#94A3B8] text-xs font-['Outfit'] text-left hover:text-[#D4AF37] transition-colors duration-200"
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="gold-divider mb-6" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-[#94A3B8] text-[0.7rem] font-['Outfit']">
          <p data-testid="footer-copyright">
            &copy; 2026 Digpu News &amp; Media. All rights reserved.
          </p>
          <p className="text-center">
            Co-organised by <span className="text-[#D4AF37]">Water &amp; Shark</span> &amp; <span className="text-[#D4AF37]">EICBI</span>
          </p>
          <div className="flex items-center gap-2 text-[#D4AF37]/70">
            <img src="https://flagcdn.com/w16/eu.png" alt="EU" className="h-3 w-auto" />
            <img src="https://flagcdn.com/w16/cy.png" alt="Cyprus" className="h-3 w-auto" />
            <img src="https://flagcdn.com/w16/in.png" alt="India" className="h-3 w-auto" />
          </div>
        </div>
      </div>
    </footer>
  );
}
